module.exports = __webpack_public_path__ + "img/p6.f11cd169.jpg";